


























































// import Component, {mixins} from 'vue-class-component';
import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {enhancedEcommerce} from "../../../shared/helpers/enhanced-ecommerce";

@Component(
  {
    name: 'catalog-product-configuration',
    components: ServiceContainer().getComponents(),
  }
)

export default class extends Vue {
  @Prop({default: 'field'}) private readonly qtyType: string;
  @Prop({default: false}) private readonly enableTooltip: boolean;
  @Prop({default: 1}) private qtyIncrement: number;
  @Prop({default: false}) private readonly isOnWishlist: boolean;

  @Prop() private readonly productData: object;
  @Prop() private readonly productBundleData: { selections: {}[] }[];

  protected qty: number = 1;
  protected configKey: number = 1;
  private addToCartIsLoading: boolean = false;
  private addedToCart: boolean = false;
  private addToCartErrorMessage: string = '';
  private wishlistToggle: boolean = false;

  private get isReady(): boolean {
    return this.productData['configurator'] ? this.configuratorComplete : true;
  }

  private get isSaleable(): boolean {
    return this.$store.getters['CatalogProduct/isSaleable'] && (this.productData['in_stock'] || !this.productData['manage_stock']);
  }

  private get productQty(): number {
    return 25;
  }

  private get configuratorComplete(): boolean {
    return this.$store.getters['CatalogConfigurator/getConfiguratorState'];
  }

  private get getConfiguratorGuid(): string {
    return this.$store.getters['CatalogConfigurator/getConfiguratorGuid'];
  }

  private get selectedOptions(): Array<object> {
    return this.$store.getters['CatalogConfigurableProduct/selectedOptions'];
  }

  private changeQty(a): void {
    if (typeof this.qty !== 'string' && this.qty > 0) {
      this.qty = a === '+' ? (this.qty + this.qtyIncrement) : a === '-' && this.qty > 0 ? (this.qty - this.qtyIncrement) : (Math.ceil(this.qty / this.qtyIncrement) * this.qtyIncrement);
    } else {
      this.qty = 1;
    }
  }

  private async productAddToCart(): Promise<void> {
    this.addToCartIsLoading = true;

    try {
      let productPayload = {
        sku: this.productData['sku'],
        qty: this.qty,
      };

      if (this.productData['product_type'] === 'configurable' && this.selectedOptions.length > 0) {
        const productOptions = {
          product_option: {
            extension_attributes: {
              configurable_item_options: this.selectedOptions.map(option => {
                return {
                  option_id: option['attributeId'],
                  option_value: option['selectedValue']
                }
              })
            }
          }
        }
        productPayload = Object.assign(productPayload, productOptions);
      }

      if (this.productData['configurator'] && '' !== this.getConfiguratorGuid) {
        const productOptions = {
          product_option: {
            extension_attributes: {
              configuration_guid: this.getConfiguratorGuid
            }
          }
        }
        productPayload = Object.assign(productPayload, productOptions);
      }

      await this.$store.dispatch('CheckoutQuote/addProductToQuote', productPayload);
      // await this.$store.dispatch('CheckoutTotals/showAddToCartModal');

      this.configKey += 1;
      this.addToCartIsLoading = false;
      this.addedToCart = true;
      this.resetAddedToCart();

    } catch (e) {
      const response = e.response.data;

      this.addToCartIsLoading = false;
      this.addToCartErrorMessage = response.message;
    } finally {
      enhancedEcommerce.addProductAddToCart(this.productData, this.qty);
      this.$store.dispatch('CheckoutTotals/showAddToCartModal');
      //await this.$store.dispatch('CheckoutTotals/showMiniCart');
    }

    await this.$store.dispatch(
      'MeasurementProtocol/fireGaEvent', {
        event: 'add_to_cart',
        data: {
          product: this.productData,
          qty: this.qty,
        }
      }
    );
  }

  private resetAddedToCart(): void {
    setTimeout(() => {
      this.addedToCart = false;
    }, 3000);
  }

  private async toggleWishlist(): Promise<void> {
    try {
      await this.$store.dispatch('CustomerWishlist/toggleWishlistProduct', this.productData['product_id']);
      await this.$store.dispatch('CustomerWishlist/updateWishlistCount', !this.wishlistToggle);
      this.wishlistToggle = !this.wishlistToggle;
    } catch (e) {
      console.log(e);
    }
  }

  private created(): void {
    this.wishlistToggle = this.isOnWishlist;
    this.$store.dispatch('CatalogProduct/getProductData', this.productData);
    if (this.productBundleData.length > 0) {
      this.$store.dispatch('CatalogBundleProduct/getAvailableOptions', this.productBundleData);
    }
    enhancedEcommerce.addProductDetail(this.productData);
  }
}
